import { useEffect } from 'react';

let previousBodyOverflowY = 'auto';

const defaultPreventer = (e) => e.preventDefault();

// TODO: when we migrate <Modal/> to a `FunctionalComponent` use this hook instead
export function usePreventWindowScroll(preventScroll: boolean) {
  useEffect(() => {
    const isServerSide = RUNTIME_ENV === 'server';
    if (isServerSide) return; // bail out;
    if (preventScroll) {
      previousBodyOverflowY = document.body.style['overflow-y'];
      document.body.style['overflow-y'] = 'hidden';
      window.addEventListener('touchmove', defaultPreventer, {
        passive: false,
      });
    } else {
      document.body.style['overflow-y'] = previousBodyOverflowY;
      document.body.style['position'] = 'relative';
      window.removeEventListener('touchmove', defaultPreventer);
    }
    return function cleanUp() {
      window.removeEventListener('touchmove', defaultPreventer);
    };
  }, [preventScroll]);
}
